import axios from "@/plugins/axios";

export default {
  setAccessToken({ commit }, payload) {
    commit("SET_ACCESS_TOKEN", payload);
    // axios.setHeader("token", payload.access_token);
    // axios.defaults.headers.common.Authorization = payload.access_token;

    axios.defaults.headers["token"] = localStorage
      .getItem("access_token")
      .substring(1)
      .slice(0, -1);
    // axios.defaults.headers["Authorization"] =
    //   localStorage.getItem("refresh_token") || "";
  },
  setRefreshToken({ commit }, payload) {
    commit("SET_REFRESH_TOKEN", payload);
  },
  setUser({ commit }, payload) {
    commit("SET_USER", payload);
  },
  setType({ commit }, payload) {
    commit("SET_TYPE", payload);
    // this.$localStore.set("type", payload, 60 * 24 * 15);
  },
  async logout({ commit }) {
    commit("SET_ACCESS_TOKEN", null);
    commit("SET_REFRESH_TOKEN", null);
    commit("SET_USER", null);
    commit("SET_TYPE", null);
  },
};
